let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("aYgZt")]).then(() => parcelRequire('absYu'));